.page {
  padding: 20px 0;
}

.toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 16px;
  flex-wrap: wrap;
}

.topSection {
  margin-bottom: 32px;
}

.categorySection {
  margin-bottom: 32px;
}

/* Content area: main column + optional sidebar (wide screens) */
.contentArea {
  display: flex;
  align-items: flex-start;
  gap: 24px;
}

.mainContent {
  flex: 1;
  min-width: 0;
}

/* Sticky sidebar — shown only on screens ≥ 900px */
.lowImpactSidebar {
  width: 280px;
  flex-shrink: 0;
  position: sticky;
  top: 20px;
  max-height: calc(100vh - 40px);
  overflow-y: auto;
}

/* Inline panel inside the story list — hidden on wide screens */
.lowImpactInline {
  display: none;
  flex-basis: 100%;
  width: 100%;
}

@media (max-width: 899px) {
  .contentArea {
    flex-direction: column;
  }

  .lowImpactSidebar {
    display: none;
  }

  .lowImpactInline {
    display: block;
  }
}

.storyList {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 20px;
}

.sentinel {
  height: 1px;
  margin-top: 20px;
}

.loadingMore {
  text-align: center;
  padding: 20px;
  color: var(--color-text-muted);
  font-size: 0.9rem;
}

.errorMsg {
  text-align: center;
  padding: 40px;
  color: var(--color-text-secondary);
}

.emptyMsg {
  text-align: center;
  padding: 60px 20px;
  color: var(--color-text-muted);
}
